import * as React from 'react';
import {
    Collapse,
    CardBody,
    Card,
    CardHeader,
    Button,
    CardTitle,
    Input,
    Row,
    Col,
    Label
} from 'reactstrap';



const NavigationPanelItem = (props: any) => {
    const [isOpen, setIsOpen] = React.useState(true);
    const [backColor, setBackColor] = React.useState("");
    const [color, setColor] = React.useState("");
    const [openIcon, setOpenIcon] = React.useState("");
    const [closeIcon, setCloseIcon] = React.useState("");

    const toggle = function () {
        setIsOpen(!isOpen);

        //check if handleOpen exists
        var handlerOpen = props.handlerOpen;
        if ((typeof handlerOpen) !== "undefined") {
            props.handlerOpen(!isOpen);
        }

    }

    const active = props.active ? props.active : false;


    React.useEffect(function () {
        var open = props.open;

        if ((typeof open) === "undefined") {
            open = true;
        }

        setIsOpen(open);

    }, [props.open])


    React.useEffect(function () {
        var bgColor = props.backColor;
        var color = props.color;
        var iconOpen = props.openIcon;
        var iconClose = props.closeIcon;


        if ((typeof bgColor) === "undefined") {
            bgColor = "#458BCA";
        }

        if ((typeof color) === "undefined") {
            color = "white";
        }

        if ((typeof iconOpen) === "undefined") {
            iconOpen = "bi bi-plus-circle";
        }

        if ((typeof iconClose) === "undefined") {
            iconClose = "bi bi-dash-circle";
        }

        setBackColor(bgColor);
        setColor(color);
        setOpenIcon(iconOpen);
        setCloseIcon(iconClose);

    }, [props])


    return (
        <React.Fragment>
            {active ?
                <div id="leftNav">
                    <CardHeader onClick={toggle}
                        style={{
                            color: color,
                            backgroundColor: backColor,
                            borderRadius: "0px",
                            fontWeight: "initial"
                        }}
                    >
                        <div className="d-flex">
                            <div className="mr-auto font-weight-bold">{props.componentName}</div>
                            <div>{(isOpen ? (<i className={closeIcon}></i>) : (<i className={openIcon}></i>))}</div>
                        </div>

                    </CardHeader>
                    <Collapse isOpen={isOpen}>
                        <Card>
                            <CardTitle tag="h6">
                                {props.subTitle}
                            </CardTitle>
                            <CardBody style={{
                                fontSize: ".9rem",
                                margin: "0 auto",
                                width: "94%"
                            }}>
                                {props.children}
                            </CardBody>
                        </Card>
                    </Collapse>
                </div> :
                (<div></div>)}
        </React.Fragment>
    );
}


export default NavigationPanelItem;